export default {
  path: 'winter-service/v2/subcontractors/:id',
  name: 'WinterService2SubcontractorDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/SubcontractorDetails.vue')
}
